import React from "react";
import ChordFinder from "./components/chord-finder-component";

function App() {
  return (
    <div className="App">
      <ChordFinder />
    </div>
  );
}

export default App;
